import React, { useState } from 'react';

const Form = () => {
	const [statusMessage, setStatusMessage] = useState('');
	const [statusType, setStatusType] = useState(''); // "success" or "error"
	const [showNotification, setShowNotification] = useState(false);
	const [formData, setFormData] = useState({
		email: '',
		societe: '',
		telephone: '',
		besoin: ''
	});
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			const response = await fetch('https://formspree.io/f/mqerevob', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData)
			});

			if (response.ok) {
				setStatusMessage('Votre message a été envoyé avec succès.');
				setStatusType('success');
			} else {
				setStatusMessage("Erreur lors de l'envoi du message.");
				setStatusType('error');
			}
		} catch (error) {
			console.error('Error:', error);
			setStatusMessage('Erreur de connexion au serveur.');
			setStatusType('error');
		} finally {
			setShowNotification(true); // Show notification
			// Automatically hide the notification after 3 seconds
			setTimeout(() => setShowNotification(false), 3000);
		}
	};

	//
	return (
		<>
			<form
				className='flex-col items-center justify-center w-full lg:w-[90%] my-8 bg-white p-8 rounded-2xl'
				onSubmit={handleSubmit}
			>
				<div className='text-left w-full font-bold text-xl sm:text-2xl lg:text-3xl text-[#87152B] '>
					Prendre RDV
				</div>
				<br />

				<div className='mb-6 font-medium text-sm sm:text-base lg:text-lg text-left'>
					Vous souhaitez prendre RDV pour votre plan de formation ou
					pour des Actions Conseil :{' '}
				</div>
				<div class='relative mb-4 flex flex-row items-stretch'>
					<span
						class='items-center whitespace-nowrap rounded-s border hidden sm:flex border-e-0 border-[#AC9961] border-solid w-20  px-3 py-[0.25rem] text-center leading-[1.6] font-bold text-black shadow-xl'
						id='basic-addon1'
					>
						Société
					</span>
					<input
						type='text'
						class='relative m-0 block flex-auto rounded  sm:rounded-l-none border border-solid border-[#AC9961] bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none  text-black placeholder:text-[#AC9961] autofill:shadow-autofill focus:border-primary shadow-xl'
						placeholder='Société ...'
						name='societe'
						value={formData.societe}
						onChange={handleChange}
						aria-label='Société'
						aria-describedby='basic-addon1'
					/>
				</div>
				<div class='relative mb-4 flex flex-wrap items-stretch'>
					<span
						class=' items-center whitespace-nowrap rounded-s border hidden sm:flex border-e-0 border-[#AC9961] border-solid w-20  px-3 py-[0.25rem] text-center leading-[1.6] font-bold text-black shadow-xl'
						id='basic-addon1'
					>
						Tél
					</span>
					<input
						type='text'
						class='relative m-0 block flex-auto rounded  sm:rounded-l-none border border-solid border-[#AC9961] bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out  focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none  text-black placeholder:text-[#AC9961] autofill:shadow-autofill focus:border-primary shadow-xl'
						name='telephone'
						value={formData.telephone}
						onChange={handleChange}
						placeholder='télephone'
						aria-label='télephone'
						aria-describedby='basic-addon1'
					/>
				</div>
				<div class='relative mb-4 flex flex-wrap items-stretch'>
					<span
						class=' items-center whitespace-nowrap rounded-s border hidden sm:flex border-e-0 border-[#AC9961] border-solid w-20  px-3 py-[0.25rem] text-center leading-[1.6] font-bold text-black shadow-xl'
						id='basic-addon1'
					>
						Email
					</span>
					<input
						type='text'
						class='relative m-0 block flex-auto rounded  sm:rounded-l-none border border-solid border-[#AC9961] bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out  focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none  text-black placeholder:text-[#AC9961] autofill:shadow-autofill focus:border-primary shadow-xl'
						placeholder='email'
						name='email'
						value={formData.email}
						onChange={handleChange}
						aria-label='email'
						aria-describedby='basic-addon1'
					/>
				</div>

				<div class='relative flex w-full flex-wrap items-stretch'>
					<span class=' items-center whitespace-nowrap rounded-s border hidden sm:flex border-e-0 border-solid w-20 px-3 border-[#AC9961] py-[0.25rem] text-center font-bold text-black shadow-xl  leading-[1.6] text-surface '>
						Besoin
					</span>
					<textarea
						class='relative m-0 block flex-auto rounded  sm:rounded-l-none border border-solid  bg-transparent bg-clip-padding px-3 py-[0.25rem]  font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out text-black focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none border-[#AC9961] placeholder:text-[#AC9961] dark:focus:border-primary shadow-xl'
						name='besoin'
						value={formData.besoin}
						onChange={handleChange}
						aria-label='With textarea'
						placeholder='With textarea'
					></textarea>
				</div>
				<div className='w-full h-[60px] flex-row items-center justify-end flex'>
					<button
						type='submit'
						class='bg-[#87152B] text-white border border-[#87152B] hover:text-[#87152B] hover:bg-[#AC9961] hover:border-[#AC9961] text-base transition-all ease-in-out duration-700 font-medium rounded-lg  w-[120px] px-5 py-2.5 text-center'
					>
						Envoyer
					</button>
				</div>
			</form>
			{/* Popup Notification */}
			{showNotification && (
				<div
					className={`fixed z-50 bottom-4 right-4 sm:right-4 sm:bottom-4 sm:left-auto left-4 sm:left-0 w-[90%] max-w-[300px] rounded-lg p-4 shadow-lg transition-all duration-300 ${
						statusType === 'success'
							? 'bg-green-100 text-green-800 border-green-500'
							: 'bg-red-100 text-red-800 border-red-500'
					}`}
				>
					<div className='font-medium'>{statusMessage}</div>
				</div>
			)}
		</>
	);
};

export default Form;
